export default "__VITE_ASSET__BJ79KImn__"